import React from 'react';
import { DeepPageWithShell } from './DeepPage';
import { usePageMeta } from '../../lib/useMeta';
import { serviceSchema } from '../../lib/schema';

const PATH = '/kids-karate';

const DATA = {
  breadcrumbs: [
    { label: 'Home', href: '/' },
    { label: 'Programs', href: '/#programs' },
    { label: 'Kids Karate' },
  ],
  eyebrow: 'Kids Program',
  h1: 'Kids Karate in Colorado Springs',
  tagline: 'Little Dragons (4\u20136) · Kids Karate (7\u201312)',
  intro:
    'Universal Kempo Karate\u2019s kids program builds confidence, focus, and real self-defense skills in a safe, supportive environment. From Little Dragons to pre-teens, we train the whole child \u2014 mind, body, and character.',
  heroImage: 'https://customer-assets.emergentagent.com/job_kempo-patch/artifacts/h78g9wha_1.jpeg',
  heroImageAlt: 'Kids karate class at Universal Kempo Karate in Colorado Springs',
  callouts: [
    { title: 'Ages 4 to 12', body: 'Age-matched groups so your child trains with peers at the same stage.' },
    { title: 'Character First', body: 'Confidence, listening, respect, and anti-bully skills alongside technique.' },
    { title: 'Parents Welcome', body: 'Watch every class. We are a family-first dojo \u2014 by design.' },
  ],
  featureList: [
    'Age-appropriate movement and games',
    'Anti-bully self-defense scenarios',
    'Discipline, listening, and respect',
    'Progressive Kempo belt system',
    'Instructor-supervised controlled contact',
    'Family-first environment',
  ],
  sections: [
    {
      eyebrow: 'Little Dragons (Ages 4\u20136)',
      heading: 'Big-energy fundamentals, done safely.',
      body: [
        'Little Dragons is where the first real karate skills take root. Classes focus on listening, focus games, coordination, and the fundamental movements \u2014 stances, basic blocks, and controlled striking patterns.',
        'Expect a lot of energy, a lot of structure, and a lot of positive reinforcement. The goal at this age is not technical perfection \u2014 it is building a kid who loves to be on the mat.',
      ],
    },
    {
      eyebrow: 'Kids Karate (Ages 7\u201312)',
      heading: 'Where the real curriculum begins.',
      body: [
        'By age seven, our students are ready for the full Kempo curriculum \u2014 strikes, blocks, flow drills, controlled partner work, and age-appropriate self-defense scenarios.',
        'This is the age where confidence shifts. Parents consistently tell us their child is more focused at school, more confident with peers, and more respectful at home within a few months of consistent training.',
      ],
      bullets: [
        'Striking, blocks, and controlled sparring',
        'Anti-bully scenario drills',
        'Belt-rank progression',
        'Respect, discipline, and leadership',
      ],
    },
    {
      eyebrow: 'Safety',
      heading: 'Zero mystery, zero pressure.',
      body: [
        'All contact is instructor-supervised and controlled. Our head instructors have decades of experience training children safely. Parents are always welcome to stay and watch \u2014 and most do.',
        'Classes run Tuesday and Thursday evenings at our Revolution location in northeast Colorado Springs. Your first two classes are free, and new students receive a free uniform.',
      ],
    },
  ],
  ctaCopy: 'Book My Child\u2019s Free Trial',
  source: 'page-kids-karate',
};

const KidsKaratePage = () => {
  usePageMeta({
    title: 'Kids Karate in Colorado Springs, CO | Universal Kempo Karate',
    description:
      'Kids karate in Colorado Springs for ages 4\u201312. Confidence, focus, anti-bully self-defense, and real Kempo technique. Two free trial classes + free uniform.',
    path: PATH,
    breadcrumbs: DATA.breadcrumbs,
    schemas: [
      {
        id: 'kids-karate-service-jsonld',
        data: serviceSchema({
          name: 'Kids Karate',
          description: 'Kids Kempo karate for ages 4\u201312 \u2014 confidence, discipline, and anti-bully self-defense.',
          slug: PATH,
          serviceType: 'Martial Arts Instruction',
        }),
      },
    ],
  });
  return <DeepPageWithShell data={DATA} />;
};

export default KidsKaratePage;
